import React from 'react';
import { values } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as analytics from '@eb/site-analytics';

import { getCanonicalSearchUrl, collectionsDuck } from '@eb/redux-destination';

import { trackEventClickInternal as trackEventClickInternalAction } from '../../../../SearchApp/actions/analytics';
import { searchByBBoxOrPlace as searchByBBoxOrPlaceAction } from '../../../../SearchApp/actions/search';
import { saveEvent as saveEventAction } from '../../../../SearchApp/actions/event';

import {
    eventsCardInfoLookup,
    getSearchContent,
    getSearchSection,
} from '../../../../SearchApp/utils';
import { hasEventResults } from '../../../../SearchApp/utils/events';
import { addSearchIdToGaAction } from '../../../../SearchApp/utils/analytics';

import { GA_SEARCH_CATEGORY } from '../../../../SearchApp/constants';
import PropTypes from 'prop-types';

import { MapContainer } from '../MapContainer';
import withStickyScrollNewLayout from '../../hoc/withStickyScrollNewLayout';

const { trackEventFromState } = analytics;

const {
    actions: {
        addOrRemoveEventToCollection: addOrRemoveEventToCollectionAction,
        createCollection: createCollectionAction,
    },
    selectors: { getFormattedCollections },
} = collectionsDuck;

export const SearchMapSection = ({
    classes,
    height,
    hoverEventCardTarget,
    onSaveEvent,
    isMobile,
    isFixed,
    setShouldScroll,
    location,
    history,
}) => {
    let component = null;

    if (!location.isOnline) {
        component = (
            <div className={classes}>
                <MapContainer
                    height={height}
                    hoverEventCardTarget={hoverEventCardTarget}
                    onSaveEvent={onSaveEvent}
                    isMobile={isMobile}
                    isFixed={isFixed}
                    setShouldScroll={setShouldScroll}
                    history={history}
                />
            </div>
        );
    }

    return component;
};

const SearchMapSectionSticky = withStickyScrollNewLayout(SearchMapSection);

export class MapPanel extends React.PureComponent {
    static propTypes = {
        onSaveEvent: PropTypes.func,
    };

    render() {
        const {
            onSaveEvent,
            location,
            hoverEventCardTarget,
            shouldLoadGoogleMap,
        } = this.props;

        if (!shouldLoadGoogleMap) {
            return null;
        }

        const searchMapProps = {
            hoverEventCardTarget,
            onSaveEvent,
            location,
        };

        return (
            <div>
                <SearchMapSectionSticky
                    {...searchMapProps}
                    history={this.props.history}
                />
            </div>
        );
    }
}

const _getEventSuggestions = (rawEvents, currencyFormat, section) => {
    const events = values(rawEvents);

    return eventsCardInfoLookup({
        bucketsContent: events,
        currencyFormat,
        section,
    });
};

export const _mapStateToProps = (state) => {
    const section = getSearchSection(state.location.isOnline);
    const results = getSearchContent(
        state.content.entities,
        state.pagination,
        state.currencyFormat,
        section,
    );

    return {
        results,
        shouldLoadGoogleMap: state.ui.isGoogleMapLoaded,
        userCollections: getFormattedCollections(state),
        hasEventResults: hasEventResults(results),
        isAuthenticated: state.auth.isAuthenticated,
        shareOptions: state.share.options,
        isLoading: state.pagination.loading,
        eventSuggestions: _getEventSuggestions(
            state.suggestions.rawEvents,
            state.currencyFormat,
            section,
        ),
        hoverEventCardTarget: state.ui.eventHoverTarget,
        allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
        featureFlags: state.app.featureFlags,
        location: state.location,
        domain: state.app.domain,
        trackGAEvent: (action) =>
            trackEventFromState(state, addSearchIdToGaAction(action, state)),
    };
};

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleLocationSelect: (...args) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    onSaveEvent: (...args) => dispatch(saveEventAction(...args, true)),
    onTrackEventClickInternal: (...args) =>
        dispatch(trackEventClickInternalAction(...args)),
    onAddOrRemoveEventToCollection: addOrRemoveEventToCollectionAction(
        GA_SEARCH_CATEGORY,
    ),
    onCreateCollection: createCollectionAction(GA_SEARCH_CATEGORY),
});

export const MapPanelContainer = withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(MapPanel),
);
